<footer class="app-footer">
  <img class="footer-eu-logo" src="../../../assets/img/europe_funded.png" alt="EU flag">
  <p class="footer-text">
    HSbooster II has received funding from the EU's Horizon Europe research and innovation programme under Grant Agreement no.&nbsp;101295066
  </p>
</footer>
